import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getTopRightInfo } from '../../../store/global/selectors';
import { handleTopRightInfo } from '../../../store/global/actions';
import CircularProgress from '@material-ui/core/CircularProgress';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': { marginTop: theme.spacing(2) },
  },
}));


const TopRightInfo = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(handleTopRightInfo({}));
  };


  const { message, ...rest } = useSelector(getTopRightInfo);

  return (
    <div className={classes.root}>
      <Snackbar {...rest} anchorOrigin={{ vertical: "top", horizontal: "right" }} style={{ zIndex: 1600 }}>
        {rest.open && (
          <Alert icon={<CircularProgress style={{ color: '#fff' }} size={20} />} severity='info'>
            {message}
          </Alert>
        )}
      </Snackbar>
    </div>
  )
}

export default TopRightInfo;